import React from "react"
import { useRef, useEffect, useState } from "react"

import mapboxgl from "!mapbox-gl" // eslint-disable-line import/no-webpack-loader-syntax

import "mapbox-gl/dist/mapbox-gl.css"
import { Switch } from "./Inputs"


const accessToken = "MY_MAPBOX_ACCESS_TOKEN"
const apiKey = "MY_MAPBOX_API_KEY"

function renderMap(map, mapContainer, lng, lat, zoom)
{
    if (map.current) return // se o mapa já estiver renderizado, não renderize novamente

    map.current = new mapboxgl.Map ({container: mapContainer.current, style: apiKey, center: [lng, lat], zoom: zoom})
}

function showHideLayer(map, layer)
{
    const visibility = map.current.getLayoutProperty(layer, "visibility")
    const newVisibility = (visibility === undefined || visibility === "visible") ? "none" : "visible"
    
    map.current.setLayoutProperty(layer, "visibility", newVisibility)
}

const ToggleLayerSwitches = ({ toggleableLayerNames }) => {
    return (
        <>
            {
                toggleableLayerNames.map((layer, index) =>
                {
                    return <Switch Name={"switch " + toggleableLayerNames[index]} Label={layer} key={layer} />
                })
            }
        </>
    )
}

export function MapboxMap()
{
    mapboxgl.accessToken = accessToken
    const mapContainer = useRef(null)
    const map = useRef(null)
    const [lng] = useState(-37.075871)
    const [lat] = useState(-10.935739)
    const [zoom] = useState(10)

    const toggleableLayerIds = ["l_aespa", "l_macrozoneamento", "l_areas_ambientais"]
    const toggleableLayerNames = ["Aeroporto", "Macrozoneamento", "Áreas ambientais"]


    useEffect(() => {
        renderMap(map, mapContainer, lng, lat, zoom)
    })

    useEffect(() => {
        toggleableLayerNames.forEach((layerName, index) =>
        {
            const switchButton = document.getElementsByName("switch " + layerName)[0]
            switchButton.onchange = () => {showHideLayer(map, toggleableLayerIds[index])};
            switchButton.checked = true
        })
    })

    return (
        <div name="mapMenu" >
            <div id="map" ref={mapContainer} className="map-container mb-3 rounded-2" style={{minHeight:"600px"}} />
            <ToggleLayerSwitches toggleableLayerNames={toggleableLayerNames} />
        </div>
    )
}